import { Component, ViewChild } from '@angular/core';
import { Workflow } from '../Model/Dto/Workflow/Workflow';
import { WorkflowService } from '../Services/Workflow/workflow.service';
import { LoginService } from '../Services/login.service';
import { HttpErrorResponse } from '@angular/common/http';
import { WorkflowItem } from '../Model/Dto/Workflow/WorkflowItem';
import { SystemService } from '../Services/system.service';
import { DxAccordionComponent } from 'devextreme-angular';
import { custom } from 'devextreme/ui/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Message } from '../Model/System/Message';
import { CatalogService } from '../Services/CatalogManagement/catalog.service';

@Component({
  selector: 'workflows',
  templateUrl: './workflows.component.html',
  styleUrl: './workflows.component.css'
})
export class WorkflowsComponent {
  @ViewChild(DxAccordionComponent, { static: true }) accordion: DxAccordionComponent;

  workflows: Workflow[] = [];
  popupExistingWorkflowplansVisible: boolean = false; 
  linkList = [];

  constructor(
    public workflowService: WorkflowService,
    public loginService: LoginService,
    public systemService: SystemService,
    public translate: TranslateService,
    public catalogService: CatalogService
  ) {

    this.createNewWorkflow = this.createNewWorkflow.bind(this);

    this.reloadWorkflows();
  }


  createNewWorkflow() {
    const newWorkflow = new Workflow(null, this.translate.instant("Workflownamen vergeben"));
    newWorkflow.editMode = true;
    this.workflows.push(newWorkflow);
    this.workflowService.updateOrCreateWorkflow(newWorkflow, this.loginService.currentCustomer.id).then((result: Workflow) => {
      this.reloadWorkflows();
    }).catch(error => {
      var response = new HttpErrorResponse(error);
      this.systemService.notifyInfo(this.translate.instant("Fehler beim Anlegen des Workflows"));
        this.reloadWorkflows();
    });
  }

  toggleWorkflowEditMode(e, wf: Workflow) {
    e.event.stopPropagation();
    wf.editMode = !wf.editMode;
    this.accordion.instance.repaint();
  }

  async updateWorkflow(e, wf: Workflow) {
    e.event.stopPropagation();
    this.toggleWorkflowEditMode(e, wf);
    await this.workflowService.updateOrCreateWorkflow(wf, this.loginService.currentCustomer.id);
  }

  async copyWorkflow(e, wf: Workflow) {
    const workflowDuplicate = new Workflow(undefined, wf.name + this.translate.instant("Duplikat"), wf.items, false);
    await this.workflowService.updateOrCreateWorkflow(workflowDuplicate, this.loginService.currentCustomer.id);
    this.reloadWorkflows();
  }

  addWorkflowItem(e, wf: Workflow) {
    e.event.stopPropagation();
    wf.items.push(new WorkflowItem(wf.items.length + 1));
    this.workflowService.updateOrCreateWorkflow(wf, this.loginService.currentCustomer.id);
  }

  deleteWorkflow = async(e, wf: Workflow) => {
    let myDialog: any;
    let txtYes = '';
    let txtNo = '';
    let txtMsg = '';
    let txtTitle = '';  
    var rootUrl = window.location.origin;
    var customerId = this.loginService.currentCustomer.id;

    var checkExistingWorkflowplans = await this.workflowService.getAllWorkflowplansByWorkflowId(wf.id, customerId);

    if (checkExistingWorkflowplans.length > 0) {
     
      checkExistingWorkflowplans.forEach(async plan => {
        var catalogName = await this.catalogService.getCatalogName(plan.catalogId, customerId);
        this.linkList.push({ text: catalogName, url: rootUrl + "/catalog/" + customerId + "/" + plan.catalogId + "/workflowplans" })
      });
      this.popupExistingWorkflowplansVisible = true;
    }
    else {
      this.translate.get('Ja').subscribe((text: string) => {
        txtYes = text;
      });
      this.translate.get('Nein').subscribe((text: string) => {
        txtNo = text;
      });
      this.translate.get('Wollen Sie den Workflow wirklich löschen').subscribe((text: string) => {
        txtMsg = text;
        if (!txtMsg.endsWith('?')) {
          txtMsg = txtMsg + '?';
        }
      });
      this.translate.get('Wirklich löschen?').subscribe((text: string) => {
        txtTitle = text;
      });

      myDialog = custom({
        title: txtTitle,
        messageHtml: txtMsg,
        buttons: [
          {
            text: txtYes,
            onClick: async (e) => {
              await this.workflowService.deleteWorkflow(wf, this.loginService.currentCustomer.id);
              this.reloadWorkflows();
            }
          },
          {
            text: txtNo,
            onClick: (e) => {
              return true;
            }
          }
        ]
      });
      myDialog.show();
    }
  }

  reloadWorkflows() {
    this.workflowService.getWorkflows(this.loginService.currentCustomer.id).then((result: Workflow[]) => {
      this.workflows = result;
    });
  }

}
